import React from 'react';
import Icon from '../../../components/AppIcon';

const AccessStatsWidget = ({ stats }) => {
  const statItems = [
    {
      label: 'Connected Tools',
      value: stats?.connected,
      icon: 'CheckCircle2',
      color: 'text-success',
      bgColor: 'bg-success/10'
    },
    {
      label: 'Pending Requests',
      value: stats?.pending,
      icon: 'Clock',
      color: 'text-warning',
      bgColor: 'bg-warning/10'
    },
    {
      label: 'Available Tools',
      value: stats?.available,
      icon: 'Package',
      color: 'text-primary',
      bgColor: 'bg-primary/10'
    },
    {
      label: 'SSO Enabled',
      value: stats?.ssoEnabled,
      icon: 'Shield',
      color: 'text-accent',
      bgColor: 'bg-accent/10'
    }
  ];

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-8">
      {statItems?.map((item, index) => (
        <div
          key={index}
          className="bg-card border border-border rounded-lg p-4 hover:shadow-elevation-1 transition-all duration-200"
        >
          <div className="flex items-center justify-between mb-2">
            <div className={`w-10 h-10 ${item?.bgColor} rounded-lg flex items-center justify-center`}>
              <Icon name={item?.icon} size={20} color={item?.color?.replace('text-', 'var(--color-)')} strokeWidth={2} />
            </div>
            <span className={`text-2xl font-bold ${item?.color}`}>{item?.value}</span>
          </div>
          <p className="text-sm text-muted-foreground">{item?.label}</p>
        </div>
      ))}
    </div>
  );
};

export default AccessStatsWidget;